import { queryOptions, useQuery } from '@tanstack/react-query';

import type { SocialProvider } from '@nucleus-commerce/api-client/admin';

import { socialPostsApi } from '../api/social-posts-api';

import { socialKeys } from './social-keys';

/** Boards read live from the network; a minute of staleness spares the per-user read limit. */
export function socialTargetsQueryOptions(storeId: string, provider: SocialProvider) {
  return queryOptions({
    queryKey: socialKeys.targets(storeId, provider),
    queryFn: () => socialPostsApi.targets(storeId, provider),
    staleTime: 60_000,
  });
}

export function useSocialTargets(storeId: string, provider: SocialProvider, enabled = true) {
  return useQuery({ ...socialTargetsQueryOptions(storeId, provider), enabled });
}
